/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ResendNativeLoginBody = zod.object({
  authMethod: zod.enum(['code', 'password']).optional(),
  channel: zod.enum(['email', 'phone']),
  csrfToken: zod.string(),
  expiresAt: zod.iso.datetime({ offset: true }),
  flowId: zod.string().min(1),
  flowKind: zod.enum(['login', 'registration', 'recovery']),
  homeRegion: zod
    .enum(['au', 'us'])
    .optional()
    .describe("One of OnEarly's regions: `au` (Australia) or `us` (United States)."),
  identifier: zod.string().min(1),
  registrationTraits: zod
    .object({
      email: zod.email(),
      name: zod.object({
        first: zod.string().min(1),
        last: zod.string().min(1),
      }),
      phone_number: zod.string().min(1),
    })
    .optional(),
  sessionTokenExchangeCode: zod.string().optional(),
});

export type ResendNativeLoginBody = zod.input<typeof ResendNativeLoginBody>;
export type ResendNativeLoginBodyOutput = zod.output<typeof ResendNativeLoginBody>;
